import type { App } from 'vue';
import type { PluginOptions } from 'vue-toastification';
import Toast, { POSITION } from 'vue-toastification';
import { VTooltip } from 'floating-vue';
import type { PluginOptions as PromptPluginOptions } from '@shared/plugins/prompts';
import { PromptPlugin } from '@shared/plugins/prompts';
import { registerComponents } from './core/components';
import VPreventRightClick from './shared/directives/VPreventRightClick';

export default {
  install: (app: App) => {
    app.use(PromptPlugin, {
      configure: (pluginApp) => {
        // make sure prompts have same core components as app
        registerComponents(pluginApp);
      },
    } as PromptPluginOptions);

    const options: PluginOptions = {
      position: POSITION.BOTTOM_RIGHT,
      timeout: 5000,
      closeOnClick: true,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: false,
      showCloseButtonOnHover: false,
      hideProgressBar: true,
      closeButton: 'button',
      icon: true,
      rtl: false,
    };
    app.use(Toast, options);
    app.directive('tooltip', VTooltip);
    app.directive('preventRightClick', VPreventRightClick);
    registerComponents(app);
  },
};
